const initialState = {
    //emp List 
    loadingPricingLeadStatus: false,
    leadPricingStatusDataError: "",
    leadPricingStatusData: [],
    leadPricingStatusCurrentPage: 0,
    leadPricingStatusTotalPage: 0,
    leadPricingStatusTotalData: 0,
    leadPricingAllStatusCount: {},

    //quote details
    loadingQuoteDetail: false,
    quoteDetailDataError: "",
    quoteDetailData: [],

    //pricing quote details
    loadingPricingQuoteDetail: false,
    pricingQuoteDetailDataError: "",
    pricingQuoteDetailData: [],
}

const PricingLeadStatusReducer = (state = initialState, action) => {
    switch (action.type) {

        //pickedRateReq List//
        case 'FIND_PRICING_LEAD_STATUS_REQUEST':
            return {
                ...state,
                loadingPricingLeadStatus: true,
                leadPricingStatusData: [],
                leadPricingStatusDataError: '',
            };
        case 'FIND_PRICING_LEAD_STATUS_SUCCESS':
            return {
                ...state,
                loadingPricingLeadStatus: false,
                leadPricingStatusData: action.payload.data,
                leadPricingStatusCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                leadPricingStatusTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                leadPricingStatusTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
                leadPricingAllStatusCount: action.payload.getCount,
            };
        case 'FIND_PRICING_LEAD_STATUS_FAILURE':
            return {
                ...state,
                loadingPricingLeadStatus: false,
                leadPricingStatusDataError: action.payload,
            };
        //emp List//

        //quote details List//
        case 'FIND_QUOTE_DETAIL_REQUEST':
            return {
                ...state,
                loadingQuoteDetail: true,
                quoteDetailData: {},
                quoteDetailDataError: '',
            };
        case 'FIND_QUOTE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingQuoteDetail: false,
                quoteDetailData: action.payload,
            };
        case 'FIND_QUOTE_DETAIL_FAILURE':
            return {
                ...state,
                loadingQuoteDetail: false,
                quoteDetailDataError: action.payload,
            };
        //quote details//

        //quote pricing details List//
        case 'FIND_PRICING_QUOTE_DETAIL_REQUEST':
            return {
                ...state,
                loadingPricingQuoteDetail: true,
                pricingQuoteDetailData: {},
                pricingQuoteDetailDataError: '',
            };
        case 'FIND_PRICING_QUOTE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingPricingQuoteDetail: false,
                pricingQuoteDetailData: action.payload,
            };
        case 'FIND_PRICING_QUOTE_DETAIL_FAILURE':
            return {
                ...state,
                loadingPricingQuoteDetail: false,
                pricingQuoteDetailDataError: action.payload,
            };
        //quote pricing details List//



        default:
            return state;
    }
}

export default PricingLeadStatusReducer;